import React, { useEffect, useRef, useState } from "react";
import { DialogButton } from "rmwc";

import getLocale from '../../utils/locale';
import "./ContactForm.scss";
import TicketService from "../../services/Ticket";
import { useTranslate } from "react-polyglot";

const ContactForm = ({ isOpen, onClose }) => {
    const t = useTranslate();
    const formRef = useRef()
    const locale = getLocale();

  const [formData, setFormData] = useState({
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setStatus({ ...status, submitting: true });

    try {
      await TicketService.createTicket({...formData, locale});

      setStatus({
        submitting: false,
        submitted: true,
        error: false,
        message: t("contactForm.messages.sentOk"),
      });
      setFormData({ subject: "", message: "" });
      setTimeout(() => {
        onClose();
        setStatus((prev) => ({ ...prev, submitted: false, message: "" }));
      }, 3000);

    } catch (error) {
      setStatus({
        submitting: false,
        submitted: true,
        error: true,
        message: t("contactForm.messages.sentFailed"),
      });
    }
  };

  return (
    <div 
      className="contact-form-container"
      style={{ display: isOpen ? 'block' : 'none' }}
    >
      <div className="contact-form-card">
        <div className="contact-form-header">
          <span>{t("contactForm.title")}</span>
          <button onClick={onClose} className="icon-close" aria-label="Close"></button>
        </div>

        <form ref={formRef} className="contact-form">
          <div className="contact-form-body">
            <div>
              <label htmlFor="subject" className="contact-form-label">{t("contactForm.fields.subject")}</label>
              <input
                id="subject"
                className="contact-form-input"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            
            <div>
              <label htmlFor="message" className="contact-form-label">{t("contactForm.fields.message")}</label>
              <textarea
                id="message"
                className="contact-form-textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={4}
              />
            </div>
            
            {status.submitted && (
              <p className={status.error ? "error-message" : "success-message"}>
                {status.message}
              </p>
            )}
          </div>
          
          <div className="contact-form-footer">
            <DialogButton
                className={`coa-dialog-button coa-button-large coa-dialog-button-accept`}
                action="accept"
                disabled={status.submitting || formData.subject.trim() === '' || formData.message.trim() === ''}
                isDefaultAction
                onClick={handleSubmit}
            >
                {status.submitting ? t("contactForm.button.sending") : t("contactForm.button.send")}
            </DialogButton>
            
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
